export default "__VITE_ASSET__CQYO9SHv__"